import React from 'react';
import { Label } from 'react-bootstrap';

// NVBDC-1406 — Day Counter and Days-Open Status Banner.
// Same green/yellow/red palette as areas/admin/shared/DaysOpen.js (different thresholds: that
// component is 30/60 day tiers for an unrelated dashboard grid, this is the 45/89/90 tiers agreed
// for this feature). The inline counter is always bold blue, independent of these tiers — the
// tiers apply only to the banner. Confirmed with requester 2026-07-28.
const TIERS = {
	green: { max: 45, background: '#43d162', color: '#000000', message: 'Submit by 90 Days' },
	yellow: { max: 89, background: '#dec02c', color: '#000000', message: 'Submit by 90 Days' },
	red: { max: Infinity, background: '#ba1111', color: '#FFFFFF', message: 'Pending Denial - Exceeded 90 Days' }
};

function tierFor(daysOpen) {
	if (daysOpen <= TIERS.green.max) return TIERS.green;
	if (daysOpen <= TIERS.yellow.max) return TIERS.yellow;
	return TIERS.red;
}

function CertificationDaysOpenStatus({ daysOpen }) {
	if (daysOpen === null || daysOpen === undefined) return null;

	const tier = tierFor(daysOpen);

	return (
		<React.Fragment>
			<strong id="daysOpenCounter" style={{ color: '#2A77E4', fontSize: '13px' }}>{daysOpen} of 90 Days Open</strong>
			{/* Centered on the nearest position:relative ancestor (the header row), independent of
			    where the counter above sits in the flow — matches the mockup's centered banner. */}
			<Label id="daysOpenBanner" style={{
				backgroundColor: tier.background,
				color: tier.color,
				fontWeight: 'bold',
				padding: '6px 12px',
				fontSize: '13px',
				position: 'absolute',
				left: '50%',
				top: '50%',
				transform: 'translate(-50%, -50%)'
			}}>
				{tier.message}
			</Label>
		</React.Fragment>
	);
}

export default CertificationDaysOpenStatus;



// WEBPACK FOOTER //
// ./src/areas/shared/components/certificationDaysOpen/CertificationDaysOpenStatus.js